import { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Menu } from '@headlessui/react'
import Button from './Button'
import cn from '../modules/cn'
import { ArrowDownSmall } from '../icons'

function Dropdown({
  label,
  icon,
  children,
  alignRight,
  fullWidth,
  buttonProps,
  disabled,
}) {
  const primaryStyle = 'bg-theme-700 hover:bg-theme-700 ring-offset-1 ring-1 ring-theme-700 text-white'
  const neutralStyle = cn(
    `bg-gray-100 hover:bg-gray-100 text-gray-800 hover:text-gray-800
    ring-offset-1 ring-1 ring-gray-100`,
  )
  const defaultStyle = cn(
    `bg-theme-300 hover:bg-theme-300 text-theme-800 hover:text-theme-800
    text-theme-800 hover:text-theme-800 focus:text-theme-800 ring-offset-1 ring-1 ring-theme-300`,
  )
  const style = (buttonProps?.neutral && neutralStyle) || (buttonProps?.primary && primaryStyle) || defaultStyle

  return (
    <Menu as="div" className={cn('relative inline-block text-left', fullWidth && 'w-full')}>
      {({ open }) => (
        <>
          <Menu.Button as={Fragment}>
            <Button
              {...buttonProps /* eslint-disable-line react/jsx-props-no-spreading */}
              trailingAddon={icon}
              fullWidth={fullWidth}
              disabled={disabled}
              className={cn(
                open && style,
              )}
            >
              {label}
            </Button>
          </Menu.Button>
          <Menu.Items
            className={cn(
              `absolute ring-0 focus:outline-none z-10 overflow-y-auto overflow-x-hidden bg-white min-w-full border
              mt-1 pt-2 pb-2 border-gray-50 shadow-sm rounded-md outline-0 text-sm max-h-64`,
              !alignRight && 'origin-top-left left-0',
              alignRight && 'origin-top-right right-0',
            )}
          >
            {children}
          </Menu.Items>
        </>
      )}
    </Menu>
  )
}

Dropdown.propTypes = {
  label: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.node, PropTypes.elementType]),
  children: PropTypes.node.isRequired,
  alignRight: PropTypes.bool,
  fullWidth: PropTypes.bool,
  buttonProps: PropTypes.shape(),
  disabled: PropTypes.bool,
}

Dropdown.defaultProps = {
  label: null,
  icon: <ArrowDownSmall />,
  alignRight: false,
  fullWidth: false,
  buttonProps: null,
  disabled: false,
}

export default Dropdown
